import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Login from '@/views/Login'
import Exam from '@/views/Exam'
import Test from '@/views/Test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '山西传人科技企业培训综合管理平台'
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
        title: '山西传人科技企业培训综合管理平台'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '山西传人科技企业培训综合管理平台'
      }
    },
    {
      path: '/exam',
      name: 'Exam',
      component: Exam,
      meta: {
        title: '山西传人科技企业培训综合管理平台 - 在线考试'
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {
        title: '山西传人科技企业培训综合管理平台 - 模拟考试'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js